import UsuarioAutenticadoLayout from "../components/UsuarioAutenticadoLayout.vue";

import Home from "../pages/Home.vue";
import PaginaNaoExiste from "../pages/erros/404.vue";
import AcessoNegado from "../pages/erros/403.vue";
import USC_21_001 from "../pages/USC_21_001.vue";
import USC_21_003 from "../pages/USC_21_003.vue";
import USC_21_004 from "../pages/USC_21_004.vue";
// import USC_21_005 from "../pages/USC_21_005.vue";
import USC_21_006 from "../pages/USC_21_006.vue";
import USC_21_007 from "../pages/USC_21_007.vue";
import USC_21_008 from "../pages/USC_21_008.vue";
import USC_21_009 from "../pages/USC_21_009.vue";
import USC_21_010 from "../pages/USC_21_010.vue";
import USC_21_011 from "../pages/USC_21_011.vue";
import USC_21_014 from "../pages/USC_21_014.vue";
import USC_21_012 from "../pages/USC_21_012.vue";
import USC_21_015 from "../pages/USC_21_015.vue";
import USC_21_017 from "../pages/USC_21_017.vue";
import USC_21_020 from "../pages/USC_21_020.vue";
import USC_21_018 from "../pages/USC_21_018.vue";
import USC_21_021 from "../pages/USC_21_021.vue";
import SistemaSuspenso from "../pages/erros/SistemaSuspenso.vue";

const routes = [
    { name: "403", path: '/403', component: AcessoNegado, meta: { requiresAuth: false } },
    { name: "404", path: '/404', component: PaginaNaoExiste, meta: { requiresAuth: false } },
    { name: "suspenso", path: '/suspenso', component: SistemaSuspenso, meta: { requiresAuth: false } },
    {
        path: "/",
        component: UsuarioAutenticadoLayout,
        children: [
            {
                name: "home",
                path: '/',
                component: Home,
                meta: { requiresAuth: false }
            },
            {
                name: 'USC.21.001',
                path: '/gerar_dram',
                component: USC_21_001,
                meta: { requiresAuth: false }
            },
            {
                name: 'USC.21.003',
                path: '/iptu',
                component: USC_21_003,
                meta: { requiresAuth: false }
            },
            {
                name: 'USC.21.004',
                path: '/relatorio_debitos_protestados',
                component: USC_21_004,
                meta: { requiresAuth: false }
            },
            // {
            //     name: 'USC.21.005',
            //     path: '/cadastro_email',
            //     component: USC_21_005,
            //     meta: { requiresAuth: false }
            // },
            {
                name: 'USC.21.006',
                path: '/relatorio_debitos_dram',
                component: USC_21_006,
                meta: { requiresAuth: false }
            },
            {
                name: 'USC.21.007',
                path: '/alteracao_endereco_correspodencia',
                component: USC_21_007,
                meta: { requiresAuth: false }
            },
            {
                name: 'USC.21.008',
                path: '/gerar_itbi_transacao',
                component: USC_21_008,
                meta: { requiresAuth: false }
            },
            {
                name: 'USC.21.009',
                path: '/perguntas_frequentes',
                component: USC_21_009,
                meta: { requiresAuth: false }
            },
            {
                name: 'USC.21.010',
                path: '/alteracao_endereco_imovel',
                component: USC_21_010,
                meta: { requiresAuth: false }
            },
            {
                name: 'USC.21.011', 
                path: '/manutencao_perguntas_frequentes',
                component: USC_21_011,
                meta: { requiresAuth: false }
            },
            {
                name: "USC.21.012", 
                path: "/emissao-divida-ativa-cartorios-de-protesto",
                component: USC_21_012,
                meta: { requiresAuth: false }
            },
            {
                name: 'USC.21.014', 
                path: '/pagamento_arquivo',
                component: USC_21_014,
                meta: { requiresAuth: false }
            },
            {
                name: 'USC.21.015', 
                path: '/confissao_issqn',
                component: USC_21_015,
                meta: { requiresAuth: false }
            },
            
            {
                name: 'USC.21.017', 
                path: '/reemisao_guia_parc_expon',
                component: USC_21_017,
                meta: { requiresAuth: true }
            },            
            {
                name: 'USC.21.020',
                path: '/postagem_faixa_AR',
                component: USC_21_020,
                meta: { requiresAuth: false }
            },
            {
                name: 'USC.21.018',
                path: '/reemitir_termo_confissao',
                component: USC_21_018,
                meta: { requiresAuth: false }
            },            
            {
              name: 'USC.21.021',
              path: '/restricao_acesso_dram',  
              component: USC_21_021,
              meta: { requiresAuth: true }
            },
        ],
    },

    { path: '*', redirect: '/404', meta: { requiresAuth: false } },
];

export default routes;
